import { Contract } from "../../../../models/Entities/Contracts/Contract";
import { ContractBranch } from "../../../../models/Entities/Contracts/ContractBranch";
import { ErrorType } from "../../../../models/HttpError";
import { Protocol } from "../../../../models/Entities/Protocols/Protocol";

// stores
import * as ContractBranchStore from '../../../../redux/middleware/ContractBranchsMiddleware';

//State
import { AppState } from "../../../../redux/reducers";


interface IProps {
    ContractId: number;
    ContractAddendumId?: number;
}
  
  interface ConnectedProps {
    isLoading: boolean;
    isUpdating: boolean;
    isUpdatedSuccessfully: boolean;
    isLoadingSuccessfully: boolean;
    failOnUpdating: boolean;
    failOnLoading: boolean;
    isDeleting: boolean;
    isDeletedSuccessfully: boolean;
    failOnDeleting: boolean;
    error: ErrorType | undefined;
    Contract: Contract | undefined;
    branches: ContractBranch[];
    Protocols: Protocol[] | undefined;
  }
  
  interface DispatchProps {
    GetAllContractsBranchs: typeof ContractBranchStore.actionCreators.GetAllContractsBranchs;
    GetContractBranchsByAddendumId: typeof ContractBranchStore.actionCreators.GetContractBranchsByAddendumId;
    GetContractBranchById: typeof ContractBranchStore.actionCreators.GetContractBranchById;
    DeleteContractBranch: typeof ContractBranchStore.actionCreators.DeleteContractBranch;
  }
  
  export type Props = IProps & ConnectedProps & DispatchProps;
  
  export const mapStateToProps = (state: AppState, ownProps: IProps) => {
    const contract = ownProps.ContractId && state.Contract && state.Contract?.list 
      ? state.Contract?.list?.find((item: Contract) => item.id === ownProps.ContractId ) 
      : undefined;
    
    let branches: ContractBranch[] = [];
    
    // If ContractAddendumId is provided, get branches from the specific addendum
    if (contract && ownProps.ContractAddendumId) {
      const addendum = contract.addendums?.find(a => a.id === ownProps.ContractAddendumId);
      branches = addendum?.branches || [];
    } 
    // Otherwise, get branches directly from contract (if they exist there)
    else if (contract) {
      branches = contract.branches || [];
    }
    
    return {
      isLoading: state.ContractBranch?.isLoadingAll,
      isUpdating: state.ContractBranch?.isUpdatingAll,
      isUpdatedSuccessfully: state.ContractBranch?.isUpdatingAllSuccess,
      isLoadingSuccessfully: state.ContractBranch?.successLoadingAll,
      failOnUpdating: state.ContractBranch?.FailUpdatingAll,
      failOnLoading: state.ContractBranch?.failOnLoadingAll,
      AddRangeFinalized: state.ContractBranch?.isAddingFinishedSuccessfully,
      isDeleting: state.ContractBranch?.isDeletingOne,
      isDeletedSuccessfully: state.ContractBranch?.successDeletingOne,
      failOnDeleting: state.ContractBranch?.failOnDeletingOne,
      error: state.ContractBranch?.error,
      Contract: contract,
      branches: branches,
      Protocols: state.MedicalProtocols?.list
    };
  };
  
  export const mapDispatchToProps = {
    ...ContractBranchStore.actionCreators
  };